import { Box, Container, Typography } from "@mui/material";

import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HomeIcon from "@mui/icons-material/Home";
import WeekendIcon from "@mui/icons-material/Weekend";

import CheckroomIcon from "@mui/icons-material/Checkroom";
import cardBg from "../../assets/images/special_service_card_bg.png";
import sectionBg from "../../assets/images/special_services_bg.png";
import sectionBgm from "../../assets/images/special_services_bg_m.png";

const specialtyServices = [
  {
    icon: <HomeIcon />,
    title: "Home Textile Care",
    items: ["Curtains & Drapes", "Comforters", "Blankets", "Bedsheets"],
  },

  {
    icon: <WeekendIcon />,
    title: "Rug Cleaning",
    items: ["Area Rugs", "Deep Cleaning", "Stain Removal", "Odour Treatment"],
  },

  {
    icon: <AutoAwesomeIcon />,
    title: "Leather & Fur Care",
    items: [
      "Leather Garments",
      "Suede Cleaning",
      "Fur Cleaning",
      "Quote On Inspection",
    ],
  },

  {
    icon: <CheckroomIcon />,
    title: "Shoe & Handbag Care",
    items: [
      "Shoe Cleaning",
      "Shoe Repair",
      "Handbag Cleaning",
      "Handbag Repair",
    ],
  },
];

export default function BeyondLaundryServices() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        backgroundImage: { xs: `url(${sectionBgm})`, md: `url(${sectionBg})` },

        backgroundSize: "cover",

        backgroundPosition: "center",

        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADER */}

        <Box
          sx={{
            textAlign: "center",

            maxWidth: "850px",

            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Beyond Laundry Services
          </Box>

          <Typography
            sx={{
              mt: 1.5,

              fontWeight: 900,

              lineHeight: 1.1,

              color: "#07122F",

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
              display: "block",
            }}
          >
            Complete Care For{" "}
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Your Home & Lifestyle
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              color: "#64748B",

              lineHeight: 1.8,

              maxWidth: "720px",

              mx: "auto",

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            From household textiles and rugs to premium leather care and custom
            apparel printing, we provide complete solutions under one roof.
          </Typography>
        </Box>

        {/* CARDS */}

        <Box
          sx={{
            mt: {
              xs: 5,
              md: 8,
            },

            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            gap: 2,
          }}
        >
          {specialtyServices.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "0 0 calc(50% - 8px)",
                  lg: "0 0 calc(25% - 15px)",
                },

                maxWidth: {
                  xs: "calc(50% - 8px)",
                  lg: "calc(25% - 15px)",
                },

                minHeight: {
                  xs: 220,
                  md: 340,
                },

                p: {
                  xs: 1.5,
                  md: 3,
                },

                position: "relative",

                overflow: "hidden",

                borderRadius: "30px",

                backgroundImage: `
                //   linear-gradient(
                //     rgba(255,255,255,.92),
                //     rgba(248,251,255,.85)
                //   ),
                  url(${cardBg})
                `,

                backgroundSize: "cover",

                backgroundPosition: "center",

                border: "1px solid rgba(255,255,255,.8)",

                boxShadow: "0 15px 40px rgba(0,87,255,.08)",

                transition: ".35s",

                "&:hover": {
                  transform: "translateY(-8px)",

                  boxShadow: "0 25px 60px rgba(0,87,255,.15)",
                },
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: 46,
                    md: 68,
                  },

                  height: {
                    xs: 46,
                    md: 68,
                  },

                  borderRadius: "20px",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  color: "#fff",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  mb: 2,

                  "& svg": {
                    fontSize: {
                      xs: 24,
                      md: 34,
                    },
                  },
                }}
              >
                {item.icon}
              </Box>

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#07122F",

                  fontSize: {
                    xs: "13px",
                    md: "24px",
                  },
                }}
              >
                {item.title}
              </Typography>

              <Box
                sx={{
                  mt: 2,

                  display: "flex",

                  flexDirection: "column",

                  gap: 1,
                }}
              >
                {item.items.map((service, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",

                      alignItems: "center",

                      gap: 0.8,
                    }}
                  >
                    <CheckCircleIcon
                      sx={{
                        color: "#0057FF",

                        fontSize: {
                          xs: 14,
                          md: 18,
                        },
                      }}
                    />

                    <Typography
                      sx={{
                        color: "#12305F",

                        fontWeight: 600,

                        fontSize: {
                          xs: "10px",
                          md: "15px",
                        },
                      }}
                    >
                      {service}
                    </Typography>
                  </Box>
                ))}
              </Box>

              <Box
                sx={{
                  position: "absolute",

                  left: 0,

                  right: 0,

                  bottom: 0,

                  height: "4px",

                  background: "linear-gradient(90deg,#0057FF,#1DB6FF)",
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
